module.exports = __webpack_public_path__ + "media/images/lightbox/loading@2x-5add32b4976240bbb0e12bb7caabc821.gif";